<template>
  <div style="width: 100%; height: 90%;">
    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-alpine"
      id="myGrid"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :headerHeight="48"
      :rowSelection="rowSelection"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @row-selected="onRowSelected"
      :rowData="rowData"
    >
    </ag-grid-vue>
    <v-btn
      color="green darken-1"
      v-on:click="addItems()"
    >Add Row</v-btn>
    <v-btn
      color="red darken-1"
      v-on:click="onRemoveSelected()"
    >Remove Selected</v-btn>
    <v-btn
      color="blue darken-1"
      @click="save"
    >Save</v-btn>
  </div>
  </v-container>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import axios from 'axios'
import { AutocompleteSelectCellEditor } from 'ag-grid-autocomplete-editor'
import 'ag-grid-autocomplete-editor/main.css'
export default {
  name: 'rakelinkdtl',
  data () {
    return {
      gridOptions: null,
      gridApi: null,
      rowSelection: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowData: null,
      editedRowIDs: new Set([]),
      editedRows: []
    }
  },
  components: {
    AgGridVue
  },
  beforeMount () {
    this.gridOptions = {};
    this.rowSelection = 'single';
    this.columnDefs = [
      { headerName: 'Srl No', field: 'srl', editable: false, type: 'numericColumn', filter: 'agTextColumnFilter' },
      { headerName: 'Link No', field: 'rake_no', type: 'numericColumn',
       comparator: (valueA, valueB, nodeA, nodeB, isInverted) => {
                if (parseInt(valueA) == parseInt(valueB)) return 0;
                return (parseInt(valueA) > parseInt(valueB)) ? 1 : -1;
            } , sortable: true
      },
      { headerName: 'Train No', field: 'train_no', filter: 'agTextColumnFilter' },
      { headerName: 'Origination', field: 'org', editable: false, filter: 'agTextColumnFilter' },
      { headerName: 'Dep', field: 'dep', editable: false, sortable: true },
      { headerName: 'Destination', field: 'dest', editable: false, filter: 'agTextColumnFilter', sortable: true },
      { headerName: 'Arr', field: 'arr', editable: false, sortable: true },
      { headerName: 'No of Car', field: 'no_of_cars', type: 'numericColumn', filter: 'agTextColumnFilter', sortable: true }
    ]
    this.rowData = [
    ];
    this.defaultColDef = {
      flex: 1,
      minWidth: 88,
      editable: true,
      resizable: true,
      onCellValueChanged: this.onCellValueChanged
    };
    this.getRakeLink()
  },
  mounted () {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    getRakeLink () {
      this.rowData = []
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/rakelink/rakelink`)
        .then(response => {
          // console.log(response.data);
          this.rowData = response.data
        })
        .catch(e => {
          console.log(e)
        })
    },


    onCellValueChanged (params) {
      // console.log(params)
      this.editedRowIDs.add(params.node.id);
    },
    save () {
      if (this.editedRowIDs.size == 0) {
        return
      }

        this.editedRowIDs.forEach( id => {
        this.editedRows.push({
              srl: this.gridApi.getRowNode(id).data.srl,
              rake_no: this.gridApi.getRowNode(id).data.rake_no,
              train_no: this.gridApi.getRowNode(id).data.train_no
            }
          )
        // console.log(this.editedRows)
        }
      );
      console.log(this.editedRows)
      var p = {
        edited_links: this.editedRows
      }
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')

      console.log(this.editedRows)
      var p = {
        edited_links: this.editedRows
      }
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')


      axios.post(`${process.env.VUE_APP_API_URL}/rakelink/rakelink`, p)
        .then(response => {
          // clear the set post update call
          this.editedRowIDs.clear();
          this.editedRows = []
        })
        .catch(e => {
          console.log(e)
        })
      // call the api to update data
    },
    onGridReady (params) { },
    populateGrid (workbook) {
      // our data is in the first sheet
      var firstSheetName = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[firstSheetName];

      // we expect the following columns to be present
      var columns = {
        'A': 'srl',
        'B': 'rake_no',
        'C': 'train_no',
        'D': 'org',
        'E': 'dep',
        'F': 'dest',
        'G': 'arr',
        'H': 'no_of_car'
      };
      this.rowData = [];

      // start at the 2nd row - the first row are the headers
      var rowIndex = 2;

      // iterate over the worksheet pulling out the columns we're expecting
      while (worksheet['A' + rowIndex]) {
        var row = {};
        Object.keys(columns).forEach(function (column) {
          row[columns[column]] = worksheet[column + rowIndex].w;
        });

        this.rowData.push(row);

        rowIndex++;
      }

      // finally, set the imported rowData into the grid

      //  gridOptions.api.setRowData(rowData);
    },
    onRowSelected (event) {
      // console.log(event)
    },
    addItems (addIndex) {
      var newItems = [
        {
          rake_no: 0,
          train_no: null,
          org: null,
          dep: null,
          dest: null,
          arr: null,
          no_of_cars: null
        }
      ];
      var selectedData = this.gridApi.getSelectedRows();
      // console.log(selectedData)
      var res = this.gridApi.applyTransaction({
        add: newItems,
        addIndex: addIndex,
      });
    },
    onRemoveSelected () {
      var selectedData = this.gridApi.getSelectedRows();
      if (selectedData.length == 0) {
        return
      }
      var p = {
        srl: selectedData[0].srl
      }
      if (confirm('Are you sure you want to delete this item?')) {
        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
        axios.delete(`${process.env.VUE_APP_API_URL}/rakelink/rakelink`, { params: p })
          .then(response => {
            //alert("Registered successfully")
            this.gridApi.applyTransaction({ remove: selectedData });
          })
          .catch(e => {
            console.log(e)
          })
      }
    }
  }
}
</script>
<style lang="scss">
@import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
.ag-header-cell-label {
  text-overflow: clip;
  overflow: visible;
  white-space: normal;
}
</style>
